import { TranRecordModel } from "./tran-record.model"

export class HandleInvtModel {
    lngClientNo: number
    lngPetNo: number
    intCodeNo: number
    strStatus: string
    strReqEmp: string
    intEmpNo: number
    strFix: string
    Trans: TranRecordModel[]
    intTotalIdx: number
    intIndex: number
    strCodeName: string
    lngSupSeq: number
    strLinkSaleTreat: string
    sglLinkUnit: number
    intClinicNo: number
    intIndicationID: number
    strRoute: string
    strLocation: string
    strFrequency: string
    strDuration: number
    strUnitDosage: string
    dblQty: number
    dblDosage: number   
    constructor(
        lngClientNo: number,
        lngPetNo: number,
        intCodeNo: number,
        strStatus: string,
        strReqEmp: string,
        intEmpNo: number,
        strFix: string,
        Trans: TranRecordModel[],
        intTotalIdx: number,
        intIndex: number,
        strCodeName: string,
        lngSupSeq: number,
        strLinkSaleTreat: string,
        sglLinkUnit: number,
        intClinicNo: number,
        intIndicationID: number,
        strRoute: string,
        strLocation: string,
        strFrequency: string,
        strDuration: number,
        strUnitDosage: string,
        dblQty: number,
        dblDosage
    ) {
        this.lngClientNo = lngClientNo
        this.lngPetNo = lngPetNo
        this.intCodeNo = intCodeNo
        this.strStatus = strStatus
        this.strReqEmp = strReqEmp
        this.intEmpNo = intEmpNo
        this.strFix = strFix
        this.Trans = Trans
        this.intTotalIdx = intTotalIdx
        this.intIndex = intIndex
        this.strCodeName = strCodeName
        this.lngSupSeq = lngSupSeq
        this.strLinkSaleTreat = strLinkSaleTreat
        this.sglLinkUnit = sglLinkUnit
        this.intClinicNo = intClinicNo
        this.intIndicationID = intIndicationID
        this.strRoute = strRoute
        this.strLocation = strLocation
        this.strFrequency= strFrequency
        this.strDuration = strDuration
        this.strUnitDosage = strUnitDosage
        this.dblQty= dblQty
        this.dblDosage = dblDosage
    }
}